import { render, staticRenderFns } from "./InpAutoScroll.vue?vue&type=template&id=35422b84"
import script from "./InpAutoScroll.vue?vue&type=script&lang=js"
export * from "./InpAutoScroll.vue?vue&type=script&lang=js"
import style0 from "./InpAutoScroll.vue?vue&type=style&index=0&id=35422b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports